"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});

var _classCallCheck2 = require("babel-runtime/helpers/classCallCheck");

var _classCallCheck3 = _interopRequireDefault(_classCallCheck2);

var _createClass2 = require("babel-runtime/helpers/createClass");

var _createClass3 = _interopRequireDefault(_createClass2);

var _ErrorApi = require("./../../../../utils/ErrorApi");

var _ErrorApi2 = _interopRequireDefault(_ErrorApi);

var _Fetch = require("./../../../../utils/Fetch");

var _Fetch2 = _interopRequireDefault(_Fetch);

var _ParamsFetch = require("./../../../../utils/ParamsFetch");

var _ParamsFetch2 = _interopRequireDefault(_ParamsFetch);

var _JsonFetch = require("./../../../../utils/JsonFetch");

var _JsonFetch2 = _interopRequireDefault(_JsonFetch);

var _generateUrl = require("./../../../../utils/generateUrl");

var _generateUrl2 = _interopRequireDefault(_generateUrl);

var _UpdateMethods = require("./../UpdateMethods");

var UpdateMethods = _interopRequireWildcard(_UpdateMethods);

function _interopRequireWildcard(obj) { if (obj && obj.__esModule) { return obj; } else { var newObj = {}; if (obj != null) { for (var key in obj) { if (Object.prototype.hasOwnProperty.call(obj, key)) newObj[key] = obj[key]; } } newObj.default = obj; return newObj; } }

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

/**
 * Serviska pro práci s objekty. Generated from cz.marbes.api.objekt.v1.ObjektService.
 */
// ##############################################################

// #             GENEROVANÝ KÓD, NEMODIFIKOVAT!!!!              #

// #                  2025-06-17T17:59:55Z                      #

// ##############################################################

var ObjektApi = function () {
  function ObjektApi() {
    (0, _classCallCheck3.default)(this, ObjektApi);
  }

  (0, _createClass3.default)(ObjektApi, null, [{
    key: "findObjektByKn",

    /**
     * Najde zaznam o objektech podle id z katastru.
     *
     * @param idKn 
     * @param typObjekt 
     * @return 
     */
    value: function findObjektByKn(idKn, typObjekt) {
      var uri = serverContextPath + "/api/objekt/v1/objekty/objektByKn";
      var headers = undefined;
      var params = { idKn: idKn, typObjekt: typObjekt };

      return _ErrorApi2.default.responseResolver(_JsonFetch2.default.get(uri, params, headers));
    }

    /**
     * Načtení číselníku druhu povrchu.
     *
     * @return 
     */

  }, {
    key: "getDruhPovrchu",
    value: function getDruhPovrchu() {
      var uri = serverContextPath + "/api/objekt/v1/objekty/druhPovrchu";
      var headers = undefined;
      var params = {};

      return _ErrorApi2.default.responseResolver(_JsonFetch2.default.get(uri, params, headers));
    }

    /**
     * Najde id objektů podle id v ext systemu.
     *
     * @param extIds 
     * @param zdroj 
     * @return id objektu / id v ext systemu
     */

  }, {
    key: "findObjektIdByExtIds",
    value: function findObjektIdByExtIds(extIds, zdroj) {
      var uri = serverContextPath + ("/api/objekt/v1/objekty/objektyId/extIds/" + zdroj);
      var headers = undefined;
      var params = {};

      return _ErrorApi2.default.responseResolver(_JsonFetch2.default.post(uri, params, extIds, headers));
    }

    /**
     * Načtení číselníku typ komunikace.
     *
     * @return 
     */

  }, {
    key: "getTypKomunikace",
    value: function getTypKomunikace() {
      var uri = serverContextPath + "/api/objekt/v1/objekty/typKomunikace";
      var headers = undefined;
      var params = {};

      return _ErrorApi2.default.responseResolver(_JsonFetch2.default.get(uri, params, headers));
    }

    /**
     * Načte informace z externích systémů podle id v externím systému. Id AbstractObjekt je id v externim systemu.
     *
     * @param extIds 
     * @param zdroj 
     * @return 
     */

  }, {
    key: "findObjektInExtSystem",
    value: function findObjektInExtSystem(extIds, zdroj) {
      var uri = serverContextPath + ("/api/objekt/v1/objekty/extSystem/" + zdroj);
      var headers = undefined;
      var params = {};

      return _ErrorApi2.default.responseResolver(_JsonFetch2.default.post(uri, params, extIds, headers));
    }

    /**
     * Vytvoří záznam o objektu v lokální databázi, ale data jsou v externím systému.
     *
     * @param objektResult 
     * @return 
     */

  }, {
    key: "createObjekt",
    value: function createObjekt(objektResult) {
      var uri = serverContextPath + "/api/objekt/v1/objekty";
      var headers = undefined;
      var params = {};

      return _ErrorApi2.default.responseResolver(_JsonFetch2.default.post(uri, params, UpdateMethods.updateObjektSearchResult_A9F268v1(objektResult), headers));
    }

    /**
     * Načtení číselníku strana komunikace.
     *
     * @return 
     */

  }, {
    key: "getStranaKomunikace",
    value: function getStranaKomunikace() {
      var uri = serverContextPath + "/api/objekt/v1/objekty/stranaKomunikace";
      var headers = undefined;
      var params = {};

      return _ErrorApi2.default.responseResolver(_JsonFetch2.default.get(uri, params, headers));
    }

    /**
     * Vrátí objekt podle id. U lokálních objektů vrátí všechny data. U externích poze informace z Eobj_objekt (id v KN, popis, ...).
     *
     * @param id 
     * @return objekt
     */

  }, {
    key: "findById",
    value: function findById(id) {
      var uri = serverContextPath + ("/api/objekt/v1/objekty/" + id);
      var headers = undefined;
      var params = {};

      return _ErrorApi2.default.responseResolver(_JsonFetch2.default.get(uri, params, headers));
    }

    /**
     * Najde polohu objektu v KN.
     *
     * @param idObjektList id objektu v eobj.
     * @return 
     */

  }, {
    key: "getObjektGeometry",
    value: function getObjektGeometry(idObjektList) {
      var uri = serverContextPath + "/api/objekt/v1/objekt/poloha";
      var headers = undefined;
      var params = {};

      return _ErrorApi2.default.responseResolver(_JsonFetch2.default.put(uri, params, idObjektList, headers));
    }

    /**
     * Aktualizuje lokalni objekt.
     *
     * @param objektInput 
     * @return 
     */

  }, {
    key: "updateObjektLocal",
    value: function updateObjektLocal(objektInput) {
      var uri = serverContextPath + "/api/objekt/v1/objekty/local";
      var headers = undefined;
      var params = {};

      return _ErrorApi2.default.responseResolver(_JsonFetch2.default.put(uri, params, UpdateMethods.updateAbstractObjekt_09F075v1(objektInput), headers));
    }

    /**
     * Najde id objektu podle id z KN.
     *
     * @param idKn 
     * @param typObjekt 
     * @return 
     */

  }, {
    key: "findObjektIdByKnId",
    value: function findObjektIdByKnId(idKn, typObjekt) {
      var uri = serverContextPath + "/api/objekt/v1/objekty/objektyIdByKn";
      var headers = undefined;
      var params = { idKn: idKn, typObjekt: typObjekt };

      return _ErrorApi2.default.responseResolver(_JsonFetch2.default.get(uri, params, headers));
    }

    /**
     * Vrátí obsah číselníku typů objektů.
     *
     * @return typy objektů
     */

  }, {
    key: "getTypObjektu",
    value: function getTypObjektu() {
      var uri = serverContextPath + "/api/objekt/v1/objekty/typObjektu";
      var headers = undefined;
      var params = {};

      return _ErrorApi2.default.responseResolver(_JsonFetch2.default.get(uri, params, headers));
    }

    /**
     * Vytvori objekt v lokální databázi.
     *
     * @param objektResult 
     * @return 
     */

  }, {
    key: "createObjektLocal",
    value: function createObjektLocal(objektResult) {
      var uri = serverContextPath + "/api/objekt/v1/objekty/local";
      var headers = undefined;
      var params = {};

      return _ErrorApi2.default.responseResolver(_JsonFetch2.default.post(uri, params, UpdateMethods.updateAbstractObjekt_09F075v1(objektResult), headers));
    }

    /**
     * Najde id objektů podle id v ENO.
     *
     * @param enoIds 
     * @return id objektu / id v ENO
     */

  }, {
    key: "findObjektIdByEnoIds",
    value: function findObjektIdByEnoIds(enoIds) {
      var uri = serverContextPath + "/api/objekt/v1/objekty/objektyId/enoIds";
      var headers = undefined;
      var params = {};

      return _ErrorApi2.default.responseResolver(_JsonFetch2.default.post(uri, params, enoIds, headers));
    }

    /**
     * smaže lokální údaje o objektu.
     *
     */

  }, {
    key: "deleteObjekt",
    value: function deleteObjekt() {
      var uri = serverContextPath + "/api/objekt/v1/objekty/{id}";
      var headers = undefined;
      var params = {};

      return _ErrorApi2.default.responseResolver(_JsonFetch2.default.delete(uri, params));
    }

    /**
     * Vrátí objekty podle jejich id v lokálním systému. Data o objektech jsou získány z externích systémů, nebo lokálních pokud jsou uložena pouze v databázi. Pokud jsou požadována pouze lokální data použijte {@link #findByIdIn(Collection)}.
     *
     * @param idObjektList 
     * @return 
     */

  }, {
    key: "findObjektByIds",
    value: function findObjektByIds(idObjektList) {
      var uri = serverContextPath + "/api/objekt/v1/objekty/ids";
      var headers = undefined;
      var params = {};

      return _ErrorApi2.default.responseResolver(_JsonFetch2.default.post(uri, params, idObjektList, headers));
    }

    /**
     * Najde objekty dle předaných parametrů.
     *
     * @param query fulltextový dotaz
     * @param obec omezení hledání za kód obce
     * @param ku omezení hledání za kód katastrálního území
     * @param zaklTyp omezení hledání dle záklaního typu objektu
     * @param typ omezení hledání dle kódů typů objektů
     * @param zdroj omezení hledání na zdroj dat
     * @param max omezení počtu vrácených záznamů
     * @return nalezené objekty
     */

  }, {
    key: "findObjektFulltext",
    value: function findObjektFulltext(query, obec, ku, zaklTyp, typ, zdroj, max) {
      var uri = serverContextPath + "/api/objekt/v1/objekty";
      var headers = undefined;
      var params = { query: query, obec: obec, ku: ku, zaklTyp: zaklTyp, typ: typ, zdroj: zdroj, max: max };

      return _ErrorApi2.default.responseResolver(_JsonFetch2.default.get(uri, params, headers));
    }
  }]);
  return ObjektApi;
}();

exports.default = ObjektApi;
//# sourceMappingURL=data:application/json;charset=utf-8;base64,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